module.exports = __webpack_public_path__ + "img/genfastlas.15bf1f26.jpg";